import type { StorePassengersSchemaType } from "@/shared/schemas/tour/storePassengersSchema";
import type { TourItem } from "@/types/services/tour/apis/Detail";
import { createStore } from "zustand/vanilla";

export type TourState = {
  filteredTours: TourItem[];
  filteredDetailTours: TourItem[];
  isFiltered: boolean;
  isLoading: boolean;
  hasAvailListBeenLoaded: boolean;
  passengers: {
    user: string | null;
    passengers: StorePassengersSchemaType | null;
  };
};

export type TourAction = {
  setFilteredTours: (value: TourState["filteredTours"]) => void;
  setFilteredDetailTours: (value: TourState["filteredDetailTours"]) => void;
  setIsFiltered: (value: TourState["isFiltered"]) => void;
  setHasAvailListBeenLoaded: (
    value: TourState["hasAvailListBeenLoaded"],
  ) => void;
  setPassengers: (value: TourState["passengers"]) => void;
};

export type TourStore = TourState & TourAction;

const defaultState: TourState = {
  filteredTours: [],
  filteredDetailTours: [],
  isFiltered: false,
  isLoading: false,
  hasAvailListBeenLoaded: false,
  passengers: {
    user: null,
    passengers: null,
  },
};

export const createTourStore = (initState: TourState = defaultState) =>
  createStore<TourStore>((set) => ({
    ...defaultState,
    setFilteredTours: (filteredTours) =>
      set(() => ({
        filteredTours: Array.isArray(filteredTours)
          ? filteredTours.slice(0, 10)
          : [],
      })),
    setFilteredDetailTours: (filteredTours) =>
      set(() => ({
        filteredDetailTours: Array.isArray(filteredTours)
          ? filteredTours.slice(0, 10)
          : [],
      })),
    setIsFiltered: (isFiltered) => set(() => ({ isFiltered })),
    setHasAvailListBeenLoaded: (hasAvailListBeenLoaded) =>
      set(() => ({ hasAvailListBeenLoaded })),
    setPassengers: (passengers) => ({ passengers }),
  }));
